import type { ProductPriceSuggestion } from "@stockline/shared/types/ai/product-price-suggestion"
import type { OfflineResourceConfig } from "../../../types"
import { PRODUCT_PRICE_SUGGESTION_TABLE } from "./db"

export const productPriceSuggestionConfig: OfflineResourceConfig<ProductPriceSuggestion> =
  {
    name: "product-price-suggestions",
    endpoints: {
      full: "/api/v2/product-price-suggestions",
      delta: "/api/v2/product-price-suggestions/changes",
      push: "/api/v2/product-price-suggestions/changes",
    },
    tableName: PRODUCT_PRICE_SUGGESTION_TABLE,
    primaryKey: "id",
    indexes: {
      companyId: "companyId",
      targetId: "targetId",
    },
    applyChange: (local, patch) => ({ ...local, ...patch }),
    // Tombstones stay in Dexie (pulls deliver them as upserts carrying
    // `deletedAt`); readers filter `deletedAt` themselves.
    softDelete: true,
  }
